/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { DELETE_FEATURE, UPDATE_FEATURE } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { CREATE_FEATURE } from "../graphql/createFeature.mutation";

const log: any = LoggerModule?.getInstance();

export interface UpdateFeatureProps {
  formData: {
    name?: string;
    year?: string;
    status?: string;
  };
  id: string;
}
export interface CreateFeatureProps {
  formData: {
    alias?: string;
    description?: string;
    img1?: string;
    img2?: string;
    isVisible?: boolean;
    minDownPayment?: string;
    regMode?: string;
  };
  id: string;
}
export interface DeleteFeatureProps {
  id: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IFeatureMethods extends IPluginMethodMap {
  updateFeature(args: any): Promise<any>;
  createFeature(args: any): Promise<any>;
  deleteFeature(args: any): Promise<any>;
}

export class FeatureService implements IAgentPlugin {
  readonly methods: IFeatureMethods;

  constructor() {
    this.methods = {
      updateFeature: this.updateFeature.bind(this),
      createFeature: this.createFeature.bind(this),
      deleteFeature: this.deleteFeature.bind(this),
    };
  }

  async createFeature(args: CreateFeatureProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: CREATE_FEATURE,
          variables: {
            data: {
              ...args,
              name: args?.name?.trim(),
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createCostumeFeature,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  async updateFeature(args: UpdateFeatureProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_FEATURE,
          variables: {
            filter: {
              _id: args?.id,
            },
            update: {
              ...args?.formData,
              name: args?.formData?.name?.trim(),
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateCostumeFeature,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  async deleteFeature(args: DeleteFeatureProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: DELETE_FEATURE,
          variables: {
            filter: {
              _id: args?.id,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
